import { render, staticRenderFns } from "./BimVideo.vue.html?vue&type=template&id=1900bae1&lang=html&external"
import script from "./BimVideo.vue.js?vue&type=script&lang=js&external"
export * from "./BimVideo.vue.js?vue&type=script&lang=js&external"
import style0 from "./BimVideo.vue.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports